import { AppCache, AppCacheStorageType, createCache } from '../../utils/cache/cache';

/**
 * A collection of caches to be used with Recoil atoms/selectors etc.
 */
export const recoilCache: Record<AppCacheStorageType, AppCache> = {
  localStorage: createCache('sd:recoil', { storageType: 'localStorage' }),
  memory: createCache('sd:recoil', { storageType: 'memory' }),
  sessionStorage: createCache('sd:recoil', { storageType: 'sessionStorage' })
};
